import { render, staticRenderFns } from "./DeliveryAddressStatus.vue?vue&type=template&id=178ee3c5"
import script from "./DeliveryAddressStatus.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports